// Het ontwerp uit de webshop-editor ophalen (akkoord Martijn 13-10-2026). Zonder bewerkteken altijd de gepubliceerde stand; met
// een geldig teken en concept=1 het concept (de api kijkt het teken na). Gaat er iets mis, dan null: de webshop zoals altijd.
import axiosInstance from "./axiosInstance";
import { apiAdres } from "../instellingen";
import { bewerkKoppen } from "../lib/bewerkmodus";

export const ontwerpAdres = (key, widgetSetupId, concept) =>
  `${apiAdres}api/Webshop/Ontwerp?key=${encodeURIComponent(key)}&widgetSetupId=${encodeURIComponent(widgetSetupId)}${concept ? "&concept=1" : ""}`;

export const haalWebshopOntwerp = async (key, widgetSetupId, concept) => {
  if (!key || !widgetSetupId) return null;
  try {
    const antwoord = await axiosInstance.get(ontwerpAdres(key, widgetSetupId, concept), { headers: concept ? bewerkKoppen() : {} });
    return antwoord?.data || null;
  } catch {
    return null;
  }
};

// Een nieuw label of een nieuwe tag vanuit de Productbewerker (bewerkteken in de kop); geeft de nieuwe keuzes.
export const maakBewerklabel = async (key, lang, vraag) => {
  const antwoord = await axiosInstance.post(
    `${apiAdres}api/Webshopbewerken/Label?key=${encodeURIComponent(key)}${lang ? `&lang=${encodeURIComponent(lang)}` : ""}`,
    vraag,
    { headers: bewerkKoppen() }
  );
  return antwoord?.data;
};
